export type NotifType = "SUCCESS" | "ERROR" | "INFO" | "WARNING";

export enum NotificationType {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  WARNING = "WARNING",
  INFO = "INFO",
}
